


<script>
    
    import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    CardTitle,
    Modal,
    Input,
  } from "sveltestrap";
</script>
<div class="page-content">
    <Container fluid>
      <!-- <Breadcrumbs title="홈" breadcrumbItem="Dashboard" /> -->
      <Row>
        <Col lg="12">
            <Card>
                <CardBody>
                    <div class="mb-4 h1 card-title"><h2>리더 보드</h2></div>
                    <p class="card-text">
                        평가 산식 : Macro F1 Score<br/>
                        평가 방식 : 제출된 모델을 (비공개) 테스트 데이터로 평가
                    </p>
                </CardBody>
            </Card>
        </Col>
        </Row>
        <Row>
        <Col lg="12">
            <Card>
                <CardBody>
                    <div class="mb-4 h1 card-title"><h2>개인 또는 팀 참여</h2></div>
                    <ul>
                        <li>
                            <p class="card-text">
                                개인 또는 팀을 이루어 참여할 수 있습니다.
                            </p>
                        </li>
                        <li>
                            <p class="card-text">
                                여러 대학(원)에 속한 여러 대학(원)생이 서로 팀을 이루어 참여할 수 있습니다.
                            </p>
                        </li>
                        <li>
                            <p class="card-text">
                                수상은 대학(원)생 팀만 가능합니다.
                            </p>
                        </li>
                        <li>
                            <p class="card-text">
                                동일인이 개인 또는 복수의 팀에 중복하여 등록할 수 없습니다.
                            </p>
                        </li>
                    </ul>
                    
                </CardBody>
            </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
            <Card>
                <CardBody>
                    <div class="mb-4 h1 card-title"><h2>외부 데이터 및 사전 학습 모델</h2></div>
                    <ul>
                        <li>
                            <p class="card-text">
                                사용에 법률적/계약상 제약이 없으며, 누구나 재배포할 수 있는 공개된 외부 데이터를 사용할 수 있습니다.<br/>
                                <u>사용한 외부 데이터의 출처는 반드시 기재해주셔야 합니다.</u>
                            </p>
                        </li>
                        <li>
                            <p class="card-text">
                                사용에 법률적/계약상 제약이 없으며 공개된 사전 학습 모델(Pre-trained Model)을 사용할 수 있습니다.<br/>
                                <u>사용한 사전 학습 모델의 출처는 반드시 기재해주셔야 합니다.</u>
                            </p>
                        </li>
                    </ul>
                    
                </CardBody>
            </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
            <Card>
                <CardBody>
                    <div class="mb-4 h1 card-title"><h2>유의사항</h2></div>
                    <ul>
                        <li>
                            <p class="card-text">
                                1일 최대 모델 제출 횟수는 2회로 제한됩니다. 기존에 제출한 모델을 취소하고 싶으시면 klaid@lawcompany.co.kr로 문의주시기 바랍니다.
                            </p>
                           
                        </li>
                        <li>
                            <p class="card-text">
                                학습에 필요한 GPU 자원을 별도로 제공드리지 않습니다.
                            </p>
                        </li>
                        <li>
                            <p class="card-text">
                                모델 학습 또는 추론 과정에서 평가 데이터셋 정보가 활용된 경우(즉, 데이터가 유출된 경우) 수상에서 제외됩니다.
                            </p>
                        </li>
                        <li>
                            <p class="card-text">
                                모델 학습, 추론 및 결과 출력 과정에서 비정상적인 방법이 사용된 경우 수상에서 제외됩니다.
                            </p>
                        </li>
                        <li>
                            <p class="card-text">
                                기타 문의사항은 klaid@lawcompany.co.kr로 알려주시기 바랍니다.
                            </p>
                        </li>
                    </ul>
                </CardBody>
            </Card>
        </Col>
      </Row>
    </Container>
  </div>